import { Button, Form, notification } from 'antd';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';

import SubHeader from '../../components/SubHeader';
import apiNetCore from '../../services/apiNetCore';
import { Tabs } from '../../styles/global';
import DadosGerais from './DadosGerais';
import FilaEmbarque from './FilaEmbarque';
import { Card } from './styles';

const { TabPane } = Tabs;

export default function DetalhesLote() {
  const { loteId } = useParams();
  const history = useHistory();
  const [form] = Form.useForm();

  const [currentTab, setCurrentTab] = useState(1);
  const [dadosLote, setDadosLote] = useState({});

  const tabs = [
    {
      key: '1',
      title: 'Dados gerais',
      content: <DadosGerais dadosLote={dadosLote} />,
    },
    {
      key: '2',
      title: 'Fila de Embarque',
      content: <FilaEmbarque dadosLote={dadosLote} />,
    },
  ];

  const breadcrumbs = [
    {
      path: '/demandas',
      breadcrumbName: 'Lotes',
    },
    {
      breadcrumbName: loteId,
    },
    {
      breadcrumbName: tabs[currentTab - 1].title,
    },
  ];

  useEffect(() => {
    async function onInit() {
      try {
        if (!loteId) return history.push('/demandas');

        const { data } = await apiNetCore.get(`/lotes-integracao/${loteId}`);

        if (!data) return history.push('/demandas');

        const lote = {
          ...data,
          cnpjPagador: data.dadoPagador.id,
          descricaoProduto: data.produtoNome,
          dataInicio: moment(data.dataInicio),
          dataFim: data.dataFim && moment(data.dataFim),
          ibgeCidadeOrigem: data.enderecoOrigem.ibgeCidade,
          ibgeCidadeDestino: data.enderecoDestino.ibgeCidade,
          ibgeCidadeExpedidor: data.enderecoExpedidor.ibgeCidade,
          ibgeCidadeRecebedor: data.enderecoRecebedor.ibgeCidade,
        };

        setDadosLote(lote);
      } catch (e) {
        notification.error({
          message: 'Ops, não foi possível recuperar os dados do lote',
          description:
            'Por favor, entre em contato com nosso suporte caso o problema persistir.',
        });
      }
    }
    onInit();
  }, [form, loteId]);

  const onTabClickChange = value => setCurrentTab(Number(value));

  const previousStep = () => {
    if (currentTab === 1) return history.push('/demandas');

    setCurrentTab(currentTab - 1);
  };

  const operations = (
    <Button className="margin-sides" onClick={previousStep}>
      Voltar
    </Button>
  );

  return (
    <>
      <SubHeader breadcrumbs={breadcrumbs} />
      <Card bordered={false} className="pt-0 height-85">
        <Tabs
          activeKey={currentTab.toString()}
          onTabClick={onTabClickChange}
          tabBarExtraContent={operations}
        >
          {tabs.map(item => (
            <TabPane tab={item.title} key={item.key}>
              {item.content}
            </TabPane>
          ))}
        </Tabs>
      </Card>
    </>
  );
}
